import { useTranslation } from 'react-i18next';
import { Reimbursement } from 'us-web-services/dist/types';

interface ReimbursementTableProps {
  reimbursements: Reimbursement[];
  formatCurrency: (amount?: number) => string;
  formatDate: (date?: Date) => string;
  formatQualifiedDependent: (value?: boolean) => string;
}

export const ReimbursementTable = ({
  reimbursements,
  formatCurrency,
  formatDate,
  formatQualifiedDependent,
}: ReimbursementTableProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className='overflow-x-auto'>
      <table className='min-w-full bg-white border border-gray-200'>
        <thead className='bg-gray-50'>
          <tr>
            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              {t('pages.reimbursements.table.voucherDeducted')}
            </th>
            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              {t('pages.reimbursements.table.servicesProvided')}
            </th>
            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              {t('pages.reimbursements.table.qualifiedDependent')}
            </th>
            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              {t('pages.reimbursements.table.startDate')}
            </th>
            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              {t('pages.reimbursements.table.endDate')}
            </th>
            <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
              {t('pages.reimbursements.table.amountReimbursed')}
            </th>
          </tr>
        </thead>
        <tbody className='bg-white divide-y divide-gray-200'>
          {reimbursements.map((reimbursement, index) => (
            <tr key={reimbursement.id || index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
                {reimbursement.voucherCode || ''}
              </td>
              <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
                {reimbursement.careTypeCategory || ''}
              </td>
              <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
                {formatQualifiedDependent(reimbursement.qualifiedDependent)}
              </td>
              <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
                {formatDate(reimbursement.startDate)}
              </td>
              <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
                {formatDate(reimbursement.endDate)}
              </td>
              <td className='px-6 py-4 whitespace-nowrap text-sm text-gray-900'>
                {formatCurrency(reimbursement.amountToDeduct)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
